import { Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import HomePage from "./Pages/HomePage";
import SinginPage from "./Pages/auth/SigninPage";
import SignupPage from "./Pages/auth/SignupPage";
import ForgotPassword from "./Pages/auth/ForgotPassword";
import { AuthContext } from "./context/AuthContext";
import { Toaster } from "react-hot-toast";
import Pricing from "./Pages/Pricing/Pricing";
import CheckOut from "./Pages/Pricing/CheckOut";
import Success from "./Pages/PaymentStatus/Success";
import Failed from "./Pages/PaymentStatus/Failed";
import { FadeLoader, HashLoader } from "react-spinners";
import GoogleAuthCallback from "./Pages/auth/GoogleAuthCallback";
import Service from "./Pages/Service/Service";
import Terms from "./Pages/TermsOfUse/Terms";
import Privacy from "./Pages/PrivacyPolicy/Privacy";
import Footer from "./components/Footer/Footer";
import AIPolicy from "./Pages/AIPolicyStatement/AIPolicy";
import PaymentHistory from "./Pages/Account/PaymentHistory/PaymentHistory";
import Account from "./Pages/Account/Account";
import Plan from "./Pages/Account/CurrentPlan/Plan";
import ScrollToTop from "./components/ScrollToTop";
import UpdateCard from "./Pages/UpdateCard/UpdateCard";
// import StripeTest from "./Pages/UpdateCard/StripeTest";
import ScrollToHash from "./components/ScrollToHash";
import PageNotFound from "./Pages/PageNotFound/PageNotFound";
import VerificationViaEmail from "./Pages/VerificationViaEmail/VerificationViaEmail";
import ClinicForm from './Pages/ClinicForm/ClinicForm';
import AddPaymentMethodCheckout from "./Pages/BetaPaymentMethod/AddPaymentMethodCheckout";
import PaymentMethodSuccess from "./Pages/BetaPaymentMethod/PaymentMethodSuccess";
import SubscriptionOptions from "./Pages/SubscriptionOptions/SubscriptionOptions";
import Waitlist from "./Pages/Waitlist/Waitlist";
import BlogPage from "./Pages/Blogs/BlogPage";
import EmailVerified from "./Pages/EmailVerified/EmailVerified";
import BetaSubscription from "./Pages/BetaSubscription/BetaSubscription";
import ParentConsent from "./Pages/ParentConsent/ParentConsent";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [email, setEmail] = useState("");
  const [username, setUserName] = useState("");
  const [userId, setUserId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const access_token = localStorage.getItem("token");
  const _email = localStorage.getItem("email");
  const _user_id = localStorage.getItem("userId");

  // payment states
  const [isSubscribed, setIsSubScribed] = useState(false);
  const [subScriptionAmount, setSubScriptionAmount] = useState(0);
  const [hasUsedFreeTrial, setHasUsedFreeTrial] = useState(false);
  const [daysLeft, setDaysLeft] = useState(0);
  const [paymentDate, setPaymentDate] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [plan, setPlan] = useState("basic");
  const [paymentStatus, setPaymentStatus] = useState("not paid");
  const [planStatus, setPlanStatus] = useState("Basic");
  const [subScriptionEndDate, setSubscriptionEndDate] = useState("");
  const [subScriptionId, setSubScriptionId] = useState("");



  useEffect(() => {
    const checkAuthentication = async () => {
      if (!access_token && !isAuthenticated) {
        return;
      }
      setIsLoading(true); // Loader only starts after access_token is confirmed

      const formData = new FormData();
      formData.append("email", _email);
      formData.append("user_id", _user_id);

      try {
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/auto_login`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
            body: formData,
          }
        );
        const data = await res.json();
        console.log(data);

        if (res.ok) {
          setIsAuthenticated(true);
          setEmail(data.user.email);
          setUserId(data.user.user_id);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false); // Always stop the loader
      }
    };

    checkAuthentication();
  }, [_email, _user_id, access_token, isAuthenticated]);

  useEffect(() => {
    const checkSubscriptionsOfUser = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/userdata_info/${_user_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${access_token}`,
            },
          }
        );
        console.log(userId);
        const data = await res.json();
        console.log(data);
        if (res.ok) {
          const subScriptionDetails = data.SubscriptionDetails;
          if (!subScriptionDetails) {
            return;
          }
          if (
            subScriptionDetails.Status === "Active" ||
            subScriptionDetails.Status === "Trial" ||
            subScriptionDetails.Status === "Beta"
          ) {
            setIsSubScribed(true);
            setDaysLeft(data.DaysLeft);
            setSubScriptionAmount(subScriptionDetails.Amount);
            setHasUsedFreeTrial(subScriptionDetails.HasUsedTrial);
            setPaymentDate(subScriptionDetails.PaymentDate);
            setSubscriptionEndDate(subScriptionDetails.SubscriptionEndDate);
            setPaymentMethod(subScriptionDetails.PaymentMethod);
            setPaymentStatus(subScriptionDetails.PaymentStatus);
            setPlan(subScriptionDetails.Plan);
            setPlanStatus(subScriptionDetails.Status);
            setSubScriptionId(subScriptionDetails.SubscriptionId);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (userId) {
      checkSubscriptionsOfUser();
    }
  }, [userId,_email, _user_id, access_token, isAuthenticated]);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated,
        email,
        setEmail,
        username,
        setUserName,
        userId,
        setUserId,
        isLoading,
        setIsLoading,
        isSubscribed,
        setIsSubScribed,
        hasUsedFreeTrial,
        setHasUsedFreeTrial,
        daysLeft,
        setDaysLeft,
        paymentDate,
        setPaymentDate,
        subScriptionEndDate,
        setSubscriptionEndDate,
        plan,
        setPlan,
        subScriptionAmount,
        setSubScriptionAmount,
        paymentMethod,
        setPaymentMethod,
        paymentStatus,
        setPaymentStatus,
        planStatus,
        setPlanStatus,
        subScriptionId,
        setSubScriptionId,
      }}
    >
      <div className="dark:bg-[#111920]">
        <header>
          <Navbar />
        </header>
        <ScrollToTop />
        <ScrollToHash />
        <Routes>
          <Route exact path="/" element={<HomePage />} />
          <Route
            exact
            path="/signup"
            element={!isAuthenticated ? <SignupPage /> : <Navigate to="/" />}
          />
          <Route
            exact
            path="/login"
            element={!isAuthenticated ? <SinginPage /> : <Navigate to="/" />}
          />
          <Route
            exact
            path="/forgotpassword"
            element={
              !isAuthenticated ? <ForgotPassword /> : <Navigate to="/" />
            }
          />
          <Route
            path="/google-auth-callback"
            element={
              !isAuthenticated ? <GoogleAuthCallback /> : <Navigate to="/" />
            }
          />
          <Route
            exact
            path="/signup/verify"
            element={<VerificationViaEmail />}
          />
          <Route exact path="/email-verified" element={<EmailVerified />} />
          <Route exact path="/beta-subscription" element={<BetaSubscription />} />
          <Route exact path="/parent-consent" element={<ParentConsent />} />
          <Route exact path="/pricing" element={<Pricing />} />
          <Route exact path="/checkout" element={<CheckOut />} />
          <Route exact path="/subscription-options" element={<SubscriptionOptions />} />
          <Route exact path="/subscription-success" element={<Success />} />
          <Route exact path="/payment/success" element={<Success />} />
          <Route exact path="/payment/failed" element={<Failed />} />
          <Route exact path="/add-payment-method" element={<AddPaymentMethodCheckout />} />
          <Route exact path="/payment-method-success" element={<PaymentMethodSuccess />} />
          <Route exact path="/contactus" element={<ClinicForm />} />
          <Route exact path="/service" element={<Service />} />
          <Route exact path="/terms" element={<Terms />} />
          <Route exact path="/privacy" element={<Privacy />} />
          <Route exact path="/ai-policy" element={<AIPolicy />} />
          <Route exact path="/ai-policy" element={<AIPolicy />} />
          <Route exact path="/blogs" element={<BlogPage />} />
          <Route exact path="/signup-for-waitlist" element={<Waitlist />} />
          <Route
            exact
            path="/update-card"
            element={isAuthenticated ? <UpdateCard /> : <Navigate to="/" />}
          />
          <Route
            path="/account"
            element={!isAuthenticated ? <Account /> : <Account />}
          >
            <Route path="/account" element={<Plan />} />
            <Route path="subscription" element={<PaymentHistory />} />
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </div>

      <Footer />
      <Toaster position="top-center" />
      {isLoading && (
        <div className="loading-spinner fixed top-0 left-0 w-screen h-screen flex justify-center items-center z-50">
          <HashLoader size={50} color={"#123abc"} loading={true} />
        </div>
      )}
    </AuthContext.Provider>
  );
}

export default App;
